import * as _m0 from "protobufjs/minimal";
import { GetCasesRequest, GetCasesResponse } from "../getcases";
import { withAuthRetry } from '../utils/authRetry';
import { getServiceBaseUrl } from '../utils/api';

export async function getCases(request: GetCasesRequest, accessToken: string, setAccessToken: (token: string | null) => void, logout: () => void): Promise<GetCasesResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const { baseUrl, stagingSuffix } = getServiceBaseUrl('adminservice');
        let url = `${baseUrl}/getcases${stagingSuffix}?offset=${request.offset}&page_size=${request.pageSize}`;
        if (request.searchQuery) {
            url += `&search_query=${encodeURIComponent(request.searchQuery)}`;
        }
        if (request.hideInternal) {
            url += `&hide_internal=true`;
        }

        const response = await fetch(
            url, {
            method: 'GET',
            headers,
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): GetCasesResponse => {
        return GetCasesResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
